import { Container } from "./styles";

import profileImage from "../../assets/sabad.png";
import htmlIcon from "../../assets/html-icon.svg";
import tailwindIcon from "../../assets/tailwind-icon.svg";
import jsIcon from "../../assets/js-icon.svg";
import mysqlIcon from "../../assets/mysql-icon.svg";
import firebaseIcon from "../../assets/firebase-icon.svg";
import pythonIcon from "../../assets/python-icon.svg";
import pytorchIcon from "../../assets/pytorch-icon.svg";
import tensorflowIcon from "../../assets/tensorflow-icon.png";
import vscodeIcon from "../../assets/vscode-icon.svg";
import githubIcon from "../../assets/github-icon.svg";
import ScrollAnimation from "react-animate-on-scroll";

export function About(){
  return(
    <Container id="about-me">
      <div className="about-text">
        <ScrollAnimation animateIn="fadeInLeft">
          <h2>about me</h2>

        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInLeft" delay={0.2 * 1000}>
          <p>My name is Sabad Modi. I am a Machine Learning Developer with a great passion for AI.
            I love helping others and working on finding solutions that help people around me.
          </p>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInLeft" delay={0.4 * 1000} style={{marginTop: "2rem", marginBottom: "2rem"}}>

          <p>
            I know a lot of libraries such as PyTorch, Tensorflow, Scikit Learn(sklearn) and more.
            My interests lie in Computer Vision, Natural Language Processing and Deep Learning Applications.
            All this, whilst trying to help people all around me
          </p>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInLeft" delay={0.6 * 1000}>

          <p>
            I am a hardworking person, who is dedicated to his work.
            Love doing what I do and focus on making an impact ont he world.
            Even if I do not know/understand a certain problem, by the end of my project, I willl know a lot more than what was only required in the project.
            I love to collaborate with others and develop new projects.
          </p>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInLeft" delay={0.7 * 1000}>
          <h3>Here are some of my main tools: </h3>
        </ScrollAnimation>
        <div className="hard-skills">

          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.1 * 1000}>
              <img src={pythonIcon} alt="Python" />
            </ScrollAnimation>
          </div>

          <div className="hability">
          <ScrollAnimation animateIn="fadeInUp" delay={0.2 * 1000}>
            <img src={pytorchIcon} alt="Pytorch" />
          </ScrollAnimation>
          </div>

          <div className="hability">
          <ScrollAnimation animateIn="fadeInUp" delay={0.3 * 1000}> 
            <img src={tensorflowIcon} alt="Tensorflow" />
          </ScrollAnimation>
          </div>

          <div className="hability">
          <ScrollAnimation animateIn="fadeInUp" delay={0.4 * 1000}> 
            <img src={firebaseIcon} alt="Firebase" />
          </ScrollAnimation>
          </div>

          <div className="hability">
          <ScrollAnimation animateIn="fadeInUp" delay={0.5 * 1000}> 
            <img src={htmlIcon} alt="HTML" />
          </ScrollAnimation>
          </div>
          <div className="hability">
          <ScrollAnimation animateIn="fadeInUp" delay={0.6 * 1000}> 
            <img src={tailwindIcon} alt="Tailwind CSS" />
          </ScrollAnimation>
          </div>

          <div className="hability">
          <ScrollAnimation animateIn="fadeInUp" delay={0.7 * 1000}>
            <img src={jsIcon} alt="JavaScript" />
          </ScrollAnimation>
          </div>

          <div className="hability">
          <ScrollAnimation animateIn="fadeInUp" delay={0.7 * 1000}>
            <img src={mysqlIcon} alt="MySQL" />
          </ScrollAnimation>
          </div>

          <div className="hability">
          <ScrollAnimation animateIn="fadeInUp" delay={0.7 * 1000}>
            <img src={vscodeIcon} alt="VS Code" />
          </ScrollAnimation>
          </div>

          <div className="hability">
          <ScrollAnimation animateIn="fadeInUp" delay={0.7 * 1000}>
            <img src={githubIcon} alt="Github" />
          </ScrollAnimation>
          </div>


        </div>
      </div>
      <div className="about-image">
        <ScrollAnimation animateIn="fadeInRight" delay={0.6 * 1000}>
          <img src={profileImage} alt="Sabad's Image" />
        </ScrollAnimation>
      </div>
    </Container>
  )
}
